export const USER_KEY = 'user';
export const LANG_KEY = 'lang';
export const USER_TOKEN_KEY = 'userToken';

const listeners = {
  [USER_KEY]: [],
  [LANG_KEY]: [],
};

function dispatcher(e) {
  const { key, newValue } = e;
  if (listeners[key] == null || !listeners[key].length) return;
  let val;
  try {
    val = JSON.parse(newValue);
  } catch (err) {
    val = newValue;
  }
  listeners[key].forEach((func) => func(val));
}
window.addEventListener('storage', dispatcher);

export const Storage = {
  addListener(key, func) {
    if (listeners[key] == null) return;
    listeners[key].push(func);
  },
  getUser() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY));
    } catch (e) {
      return null;
    }
  },
  getUserId(user = null) {
    if (user != null) return user;
    const u = this.getUser();
    return u != null ? u.id : null;
  },
  setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  removeUser() {
    localStorage.removeItem(USER_KEY);
  },
  getLang() {
    const lang = localStorage.getItem(LANG_KEY);
    return lang != null ? lang : 'en';
  },
  setLang(lang) {
    localStorage.setItem(LANG_KEY, lang);
  },
  removeLang() {
    localStorage.removeItem(LANG_KEY);
  },
  setTokenExpireTime(expiresIn) {
    localStorage.setItem('expiresIn', expiresIn);
  },
  getTokenExpireTime() {
    return localStorage.getItem('expiresIn');
  },
  setToken(token) {
    localStorage.setItem(USER_TOKEN_KEY, token);
    const targetTimestamp = localStorage.getItem('expiresIn');
    const currentTime = Math.floor(Date.now() / 1000);
    const timeDifference = targetTimestamp - currentTime;
    if (timeDifference > 0) {
      setTimeout(() => {
        localStorage.clear();
        window.location.href = window.location.origin;
      }, timeDifference * 1000);
    }
  },
  getToken() {
    return localStorage.getItem(USER_TOKEN_KEY);
  },
};
export default Storage;
